import {connect} from 'react-redux';

import {
    createMetSelectWrapper,
    MetSelectDropdown,
    MetSelectInput,
    MetSelectList,
} from 'topmeteo/general/components/MetSelectWrapper';

import {changeProduct} from 'topmeteo/base-image/actionCreators';
import {getProductGroups, getSortedProducts} from 'topmeteo/general/selectors';

import ProductItem from './ProductItem';

const ProductSelect = ({title, items, groups, productID, onChange, ...props}) => (
    <div className="met-select-wrapper has-mobile-short-label">
        <span className="emulate-short-label">
            {title}
        </span>
        <select className="met-select" value={productID} onChange={onChange}>
            {groups.map(({label, products}) => (
                <optgroup key={label} label={label}>
                    {products.map(({id, title}) => (
                        <option key={id} value={id}>{title}</option>
                    ))}
                </optgroup>
            ))}
        </select>
        <MetSelectDropdown {...props}>
            <MetSelectInput {...props} value={title} />
            <MetSelectList {...props}>
                {items.map(product => <ProductItem {...product} key={product.id} />)}
            </MetSelectList>
        </MetSelectDropdown>
    </div>
);

const ProductSelectWrapper = createMetSelectWrapper(ProductSelect);

const mapStateToProps = state => {
    const {productID, products} = state;
    const {title} = products[productID] || {};

    return {
        items: getSortedProducts(state),
        groups: getProductGroups(state),
        productID,
        title,
    };
};

const mapDispatchToProps = dispatch => ({
    onChange: ({target: {value}}) => dispatch(changeProduct(+value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductSelectWrapper);
